export const MODULE_NAME = 'toastMessages';
export const MESSAGE_STATE = 'toastMessages';
export const SET_TOAST_MESSAGES = 'SetToastMessages';
export const TOAST_MESSAGES_PUSH = 'toastMessages/push';
